<template>
  <v-container>
    <div v-if="loading" class="d-flex justify-center">
      <circles-loader></circles-loader>
    </div>
    <div v-else-if="valid" class="pa-0">
      <v-card-actions class="mb-2">
        <v-row no-gutters>
          <v-col cols="6" class="pr-1">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn x-large block color="primary" elevation="0" v-on="on">
                  <v-icon class="mr-1">mdi-dots-vertical</v-icon>
                  {{ $t('message.actions') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="newMemberDialog = true">
                  <v-list-item-title>
                    <v-icon class="mr-1">mdi-account-plus-outline</v-icon>
                    {{ $t('message.add_member') }}
                  </v-list-item-title>
                </v-list-item>
                <v-list-item @click="navigateTo({ name: 'editmember' })">
                  <v-list-item-title>
                    <v-icon class="mr-1">mdi-account-edit-outline</v-icon>
                    {{ $t('message.edit_member') }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
          <v-col cols="6" class="pl-1">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn x-large block color="primary" elevation="0" v-on="on">
                  <v-icon class="mr-1">mdi-widgets-outline</v-icon>
                  {{ $t('message.widgets') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="handleNavigateWithLocation({ name: 'full-screen-checkins' })">
                  <v-list-item-title>
                    <v-icon class="mr-1">mdi-map-marker-check-outline</v-icon>
                    {{ $t('message.class_widget') }} <span class="error--text">BETA</span>
                  </v-list-item-title>
                  <v-list-item-action>
                    <v-icon>mdi-fullscreen</v-icon>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item @click="handleNavigateWithLocation({ name: 'full-screen-schedule' })">
                  <v-list-item-title>
                    <v-icon class="mr-1">mdi-calendar-today-outline</v-icon>
                    {{ $t('message.schedule_widget') }} <span class="error--text">BETA</span>
                  </v-list-item-title>
                  <v-list-item-action>
                    <v-icon>mdi-fullscreen</v-icon>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item @click="navigateTo({ name: 'full-screen-timer', query: { mode: 'timer' } })">
                  <v-list-item-title>
                    <v-icon class="mr-1">mdi-timer-outline</v-icon>
                    {{ $t('message.timer_widget') }} <span class="error--text">BETA</span>
                  </v-list-item-title>
                  <v-list-item-action>
                    <v-icon>mdi-fullscreen</v-icon>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item @click="handleNavigateWithLocation({ name: 'full-screen-timer', query: { mode: 'all' } })">
                  <v-list-item-title>
                    <v-icon class="mr-1">mdi-timer-star-outline</v-icon>
                    {{ $t('message.timer_attendance_widget') }} <span class="error--text">BETA</span>
                  </v-list-item-title>
                  <v-list-item-action>
                    <v-icon>mdi-fullscreen</v-icon>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item
                  @click="handleNavigateWithLocation({ name: 'full-screen-timer', query: { mode: 'all', navigation: '2d' } })">
                  <v-list-item-title>
                    <v-icon class="mr-1">mdi-timer-star-outline</v-icon>
                    {{ $t('message.timer_attendance_widget_2d') }} <span class="error--text">BETA</span>
                  </v-list-item-title>
                  <v-list-item-action>
                    <v-icon>mdi-fullscreen</v-icon>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item @click="navigateTo({ name: 'custompages' })">
                  <v-list-item-title>
                    <v-icon class="mr-1">mdi-book-open-page-variant-outline</v-icon>
                    {{ $t('message.custom_apps') }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-divider></v-divider>
      <div class="mt-1 text-h4 text-center">{{ $t('message.staff_checkin') }}</div>
      <v-layout>
        <v-flex xs12 justify-center>

          <div class="text-center">
            <v-container v-if="academy">
              <v-layout class="d-flex justify-center flex-wrap">
                <v-btn class="ma-2" fab dark color="secondary" @click="clickNumber(1)">1</v-btn>
                <v-btn class="ma-2" fab dark color="secondary" @click="clickNumber(2)">2</v-btn>
                <v-btn class="ma-2" fab dark color="secondary" @click="clickNumber(3)">3</v-btn>
                <v-btn class="ma-2" fab dark color="secondary" @click="clickNumber(4)">4</v-btn>
                <v-btn class="ma-2" fab dark color="secondary" @click="clickNumber(5)">5</v-btn>
                <v-btn class="ma-2" fab dark color="secondary" @click="clickNumber(6)">6</v-btn>
                <v-btn class="ma-2" fab dark color="secondary" @click="clickNumber(7)">7</v-btn>
                <v-btn class="ma-2" fab dark color="secondary" @click="clickNumber(8)">8</v-btn>
                <v-btn class="ma-2" fab dark color="secondary" @click="clickNumber(9)">9</v-btn>
                <v-btn class="ma-2" fab dark color="secondary" @click="clickNumber(0)">0</v-btn>
                <v-btn class="ma-2" fab dark color="secondary"
                  @click="clickNumber(-1)"><v-icon>backspace</v-icon></v-btn>
              </v-layout>
            </v-container>
            <div class="text-center code-display">{{ checkinCode }}</div>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn x-large elevation="0" color="primary" :disabled="!validNumber" @click="processCheckin()">
                <v-progress-circular v-if="checkingIn" class="mr-1" indeterminate color="white"></v-progress-circular>
                {{ $t('message.staff_checkin') }}
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
            <v-card-text v-if="message" class="d-flex justify-center error--text">
              <h2>{{ message }}</h2>
            </v-card-text>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <v-dialog width="100%" v-model="pickClassLocationDialog">
      <v-card outlined>
        <v-card-title>
          <v-icon class="mr-2">mdi-map-marker-outline</v-icon>
          {{ $t('message.class_location') }}
        </v-card-title>
        <v-card-text>
          <v-select outlined dense hide-details v-model="selectedClassLocation" :items="availableClassLocations"
            :label="$t('message.select_class_location')"></v-select>
        </v-card-text>
        <v-card-actions>
          <v-btn elevation="0" color="primary" @click="confirmLocationNavigation()">
            {{ $t('message.confirm') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="0" color="secondary" @click="pickClassLocationDialog = false">
            {{ $t('message.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="100%" v-model="newMemberDialog">
      <v-card outlined>
        <v-card-title>
          {{ $t('message.new_member_form') }}
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-switch hide-details :label="$t('message.i_dont_bjj')" v-model="newMember.notBjjUser"></v-switch>
            <v-switch :label="$t('message.member_is_minor')" v-model="newMember.isMinor">
            </v-switch>
            <v-icon v-if="newMember.isMinor" color="primary" class="ml-2 mb-2">mdi-baby-face-outline</v-icon>
            <v-icon v-else-if="newMember.notBjjUser" color="primary"
              class="ml-2 mb-2">mdi-account-remove-outline</v-icon>
            <v-text-field :label="$t('message.first_name')" v-model="newMember.fName" autocomplete="false" required
              outlined dense></v-text-field>
            <v-text-field :label="$t('message.last_name')" v-model="newMember.lName" required outlined dense>
            </v-text-field>
            <v-text-field :rules="emailRules" @keyup="checkExistingUser()" label="Email" v-model="newMember.email"
              required outlined dense></v-text-field>
            <GenderSelect :icon="false" v-model="newMember.gender"
              v-show="!newMember.existing || !newMember.existing.gender" />
            <v-text-field v-show="false" type="password" :label="$t('message.password')" v-model="newMember.password"
              outlined dense></v-text-field>
            <BeltsSelect v-if="!newMember.notBjjUser" v-model="newMember.belt" />
            <v-card-text class="mt-0 pl-0 pt-0">
              <div class="text-subtitle-2">{{ $t('message.birthday') }}</div>
              <DatePicker :show-time="false" v-model="newMember.dob" :past-event="true">
              </DatePicker>
            </v-card-text>
            <countries-select v-model="newMember.nationality"
              v-show="!newMember.existing || !newMember.existing.nationality" />
            <v-switch hide-details :disabled="newMember.isMinor" :label="$t('message.old_enough')"
              v-model="newMember.ageMin">
            </v-switch>
            <div v-html="newMemberError" class="error--text text-center pa-1"></div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="registring || (!newMember.isMinor && !newMember.ageMin)" elevation="0" large color="primary"
            @click="addNewMember()">
            <v-progress-circular v-if="registring" indeterminate color="white"></v-progress-circular>
            {{ $t('message.submit') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="0" large color="secondary" @click="navigateTo({ name: 'checkin' });">
            {{ $t('message.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirmMessageDialog" width="50%">
      <v-card outlined v-if="checkedInUser" class="pa-2">
        <v-card-text class="text-h6 text-center">
          <h2>{{ checkedInUser.displayName }}</h2>
        </v-card-text>
        <v-card-text class="text-center">
          <v-avatar v-if="checkedInUser.userImageSmall" size="150">
            <ImageDisplay :src="checkedInUser.userImageSmall" alt="avatar" />
          </v-avatar>
        </v-card-text>
        <v-card-text class="text-h4 success--text text-center">
          <div>
            <v-icon color="success" size="30" style="margin-right:5px">{{ checkedIn ? 'login' : 'logout' }}</v-icon>{{
              actionMessage }}
          </div>
          <v-progress-linear v-if="checkingIn" class="mr-1" indeterminate color="success"></v-progress-linear>
        </v-card-text>
        <v-card-actions v-if="message">
          <v-btn x-large block elevation="0" color="secondary" @click="headBack()">
            {{ $t('message.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import CirclesLoader from "@/components/displays/CirclesLoader.vue";
import BeltsSelect from "@/components/inputs/BeltsSelect.vue";
import CountriesSelect from "@/components/inputs/CountriesSelect.vue";
import DatePicker from "@/components/inputs/DateTimePicker.vue";
import GenderSelect from "@/components/inputs/GenderSelect.vue";
import Api from "@/services/Api";

export default {
  name: 'Checkin',
  data() {
    return {
      memberId: this.$route.query.m,
      loading: true,
      loadingClasses: false,
      validNumber: false,
      valid: true,
      message: null,
      academy: null,
      altCheckin: false,
      checkedInUser: null,
      actionMessage: null,
      selectedAcademyClassId: null,
      availableClasses: null,
      checkinCode: '',
      checkinUserId: null,
      checkinUserName: null,
      confirmMessageDialog: false,
      checkedIn: false,
      checkingIn: false,
      academyCountry: 'US',
      closeTimer: null,
      newMemberDialog: null,
      newMember: {},
      newMemberError: null,
      hasCustomPages: false,
      existingNewMember: null,
      availableClassLocations: [],
      pickClassLocationDialog: false,
      selectedClassLocation: null,
      pendingNavigationRoute: null,
      registring: false,
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(\s)*[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*(\s)*$/.test(
            v
          ) || this.$t("message.invalid_email"),
      ],
    }
  },
  components: {
    CirclesLoader,
    DatePicker,
    GenderSelect,
    BeltsSelect,
    CountriesSelect,
  },
  created() {
    if (!this.$store.state.tabletManagedAcademy) {
      this.logout();
    }
    Api().get('admintablet/academy/' + this.$store.state.tabletManagedAcademy + '/custompages')
      .then(response => {
        const data = response.data;
        if (data && data.pages && data.pages.length > 0) {
          this.hasCustomPages = true;
        }
      });
    Api().get('admintablet/academy/' + this.$store.state.tabletManagedAcademy)
      .then(response => {
        const data = response.data;
        if (data) {
          if (!data.active) {
            this.navigateTo({ name: 'inactiveaccount' });
            return;
          }
          if (data.configuration)
            this.altCheckin = data.configuration.altTabletCheckin;
          if (data.city && data.city.country)
            this.academyCountry = data.city.country;
          this.loading = false;
          this.academy = data;
          this.checkValidity();
          this.setLang(data.preferredLanguage);
          if (data.classLocations && data.classLocations.length > 0) {
            this.availableClassLocations = data.classLocations;
            this.availableClassLocations.unshift(this.$t('message.none'));
          }
        }
      })
      .catch(e => {
        if (e) {
          this.$store.dispatch("setToken", null);
          this.$store.dispatch("setTabletId", null);
          this.$store.dispatch("setTabletSelectedAcademy", null);
          this.$store.dispatch("setTabletManagedAcademy", null);
          localStorage.removeItem("tablet_token");
          window.location = 'login';
        }
      });
    this.clearNewMember();
  },
  watch: {
    checkinCode: {
      immediate: true,
      handler: function () {
        this.checkCodeValidity()
      }
    }
  },
  methods: {
    handleNavigateWithLocation(route = { name: '', query: {} }) {
      if (!this.availableClassLocations || this.availableClassLocations.length < 2) {
        this.navigateTo(route);
        return;
      }
      this.pendingNavigationRoute = route;
      this.selectedClassLocation = this.availableClassLocations[0] || null;
      this.pickClassLocationDialog = true;
    },
    confirmLocationNavigation() {
      this.pickClassLocationDialog = false;
      if (!this.pendingNavigationRoute) return;
      const route = JSON.parse(JSON.stringify(this.pendingNavigationRoute));
      const noneLabel = this.$t('message.none');
      if (this.selectedClassLocation && this.selectedClassLocation !== noneLabel) {
        route.query = { ...(route.query || {}), location: this.selectedClassLocation };
      }
      this.navigateTo(route);
      this.pendingNavigationRoute = null;
    },
    clearNewMember() {
      this.newMember = {
        dob: new Date(),
        notBjjUser: false,
        isMinor: false,
        nationality: this.academyCountry
      };
    },
    newMemberReady() {
      if (!this.newMember.fName || this.newMember.fName == "" || !this.newMember.lName || this.newMember.lName == "") {
        this.newMemberError = this.$t('message.invalid_name');
        return false;
      }
      if (!this.newMember.dob) {
        this.newMemberError = this.$t('message.invalid_dob');
        return false;
      }
      if (this.existingNewMember && !this.newMember.isMinor) {
        this.newMemberError = this.$t('message.email_in_use');
        return false;
      } else if (this.existingNewMember && this.existingNewMember.user && this.newMember.isMinor) {
        this.newMember.guardianUser = this.existingNewMember._id;
      }
      return true;
    },
    addNewMember() {
      const today = new Date();
      const year = today.getFullYear();
      if (this.newMemberReady()) {
        this.newMemberError = null;
        this.newMember.password = this.newMember.fName.replaceAll(' ', '') + this.newMember.lName.replaceAll(' ', '') + year;
        if (this.existingNewMember && this.existingNewMember.visitor) {
          this.registerExistingUser();
        } else {
          this.registerNewMember()
        }
      }
    },
    registerExistingUser() {
      if (!this.existingNewUser || !this.existingNewUser._id) {
        this.showAlert("error", this.$t("message.fill_all_params"));
        return;
      } else {
        this.registring = true;
        Api()
          .post(
            "admintablet/academy/" + this.$store.state.tabletManagedAcademy + "/connect/existing/" + this.existingNewUser._id,
          )
          .then((response) => {
            try {
              if (response.data) {
                this.navigateTo({ name: 'viewmemberdocuments', params: { memberId: response.data._id } });
              }
            } catch (e) {
              console.log(e);
              this.showAlert("error", "Oops!", "Error :(");
            }
          })
          .catch(() => {
            this.registring = false;
            this.newMemberError = this.$t('message.error');
            this.showAlert("error", "Error :(");
          });
      }
    },
    registerNewMember() {
      try {
        this.registring = true;
        if (this.newMember.password) {
          let buff = new Buffer(this.newMember.password);
          let base64data = buff.toString("base64");
          this.newMember.password = base64data;
        }
        let d = new Date(this.newMember.dob);
        d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0))
        this.newMember.dob = d;
        this.newMember.academy = this.$store.state.tabletSelectedAcademy;
        if (this.newMember.notBjjUser) this.newMember.belt = "white";
        this.newMember.existing = null;
        this.newMember.email = this.newMember.email.trim().toLowerCase();
        Api()
          .post(
            "admintablet/academy/" + this.$store.state.tabletManagedAcademy + "/new_member",
            this.newMember
          )
          .then((response) => {
            try {
              if (response.data) {
                const newMember = response.data.newMember;
                this.navigateTo({ name: 'viewmemberdocuments', params: { memberId: newMember._id } });
              }
            } catch (e) {
              console.log(e);
            }
          })
          .catch((e) => {
            this.registring = false;
            this.newMemberError = this.$t('message.error');
            if (e.response.status == 409) {
              this.showAlert(
                "error",
                "Oops!",
                this.$t("message.already_a_user"),
                9000
              );
            } else {
              this.newMemberError = this.$t('message.error');
              this.showAlert("error", "Oops!", "Error :(");
            }
          });
      } catch (err) {
        console.log(err);
        this.newMemberError = this.$t('message.error');
        this.registring = false;
      }

    },
    checkExistingUser() {
      if (this.newMember.isMinor) {
        this.existingNewMember = null;
        return;//Don't check if we are adding a minor, emails wont matter 
      }
      const email = this.newMember.email;
      if (email && email.indexOf('@') > 0) {
        Api()
          .post(
            'admintablet/academy/' + this.$store.state.tabletManagedAcademy + '/check/email', { email: email }
          )
          .then((response) => {
            if (response && response.data.user) {
              this.existingNewMember = response.data.user;
            } else if (response && response.data.visitor) {
              this.newMember = {};
              this.newMember.email = response.data.visitor.email;
              const split = response.data.visitor.name.split(' ');
              this.newMember.fName = split[0];
              this.newMember.visitorId = response.data.visitor._id;
              if (response.data.visitor.isVisitor)
                this.newMember.isVisitor = true;
              else
                this.newMember.isProspect = true;
              if (split[1])
                this.newMember.lName = split[1];
            } else {
              this.existingNewMember = null;
            }
          });
      }
    },
    logout() {
      this.$store.dispatch("setTabletToken", null);
      this.$store.dispatch("setTabletId", null);
      this.$store.dispatch("setTabletSelectedAcademy", null);
      this.$store.dispatch("setTabletManagedAcademy", null);
      this.$store.dispatch("setTabletLanguage", null);
      localStorage.removeItem("tablet_token");
      window.location = 'login';
    },
    checkValidity() {
      if (this.selectedAcademy) {
        this.valid = true;
      }
    },
    clickNumber(num) {
      if (num < 0) {
        if (this.checkinCode.length > 0) {
          //deleting
          this.checkinCode = this.checkinCode.substring(0, this.checkinCode.length - 1);
        }
      } else {
        if (this.checkinCode.length < 6)
          this.checkinCode += num + '';
      }
    },
    checkCodeValidity() {
      if (this.checkinCode && this.checkinCode.length == 6)
        this.validNumber = true;
      else
        this.validNumber = false;
    },
    processCheckin() {
      this.message = null;
      this.checkin();
    },
    headBack() {
      clearTimeout(this.closeTimer);
      this.navigateTo({ name: 'checkin' });
    },
    checkin() {
      this.checkingIn = true;
      this.message = null;
      const date = new Date();
      const postData = {
        date: date.toString(),
        day: this.getDayString(date),
        time: date,
        academyId: this.$store.state.tabletSelectedAcademy,
        startTime: date.getHours()
      };
      //var code = this.checkinCode.replace(/-/g,'');
      let code = this.checkinCode;
      if (!code)
        code = this.checkinUserId;
      if (!code) {
        this.message = this.$t('Error');
        return;
      }
      this.checkedInUser = null;
      this.message = null;
      Api().post('admintablet/academy/' + this.$store.state.tabletManagedAcademy + '/staff/checkin/' + code, postData)
        .then(response => {
          const data = response.data;
          if (data) {
            const vm = this;
            this.confirmMessageDialog = true;
            this.checkedInUser = data.member;
            this.checkedIn = data.checkedIn;
            this.actionMessage = this.$t('message.' + data.localizedMessage);
            this.closeTimer = setTimeout(function () {
              vm.navigateTo({ name: 'checkin' });
            }, 10000);
          }
        })
        .catch(e => {
          if (e && e.response.data && e.response.data.localizedMessage) {
            this.message = this.$t('message.' + e.response.data.localizedMessage);
          }
          this.checkingIn = false;
        })
    }
  },
}
</script>
<style>
.code-display {
  margin-top: -10px;
  font-size: 3em;
  text-align: center;
  width: 100%;
  height: 60px
}

@media only screen and (max-width: 541px) {}

@media only screen and (min-width: 542px) {}
</style>